<template>
  <div style="margin: 0 48px 8px;">
    <el-form ref="formRef" :model="standardForm" label-width="auto" label-position="right">
      <el-form-item label="所属门店：">
        <el-select v-model="shopId" placeholder="选择所属门店" class="select-item">
          <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打卡类型：">
        <el-select v-model="type" placeholder="选择打卡类型" class="select-item">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域：">
        <el-input v-model="standardForm.area" placeholder="请输入区域" maxlength="10"/>
      </el-form-item>
      <el-form-item label="位置：">
        <el-input v-model="standardForm.location" placeholder="请输入位置" maxlength="10"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="standardForm.orderNum" placeholder="数值越高越靠前"/>
      </el-form-item>
      <el-form-item label="图片：" v-if="idx > -1">
        <div>
          <el-space style="margin-bottom: 8px" wrap>
            <div class="img-box" v-for="(item, index) in imgArray" :key="item.id">
              <el-image style="width: 80px; height: 80px; cursor: pointer" fit="cover" :src="item.smallImg" @click="editStandardImg(index, item)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              <div class="delIcon" @click="delImg(item, index)"><ElIcons name="CloseBold" color="#ffffff"></ElIcons></div>
            </div>
<!--            <div class="add" v-if="imgArray.length > 0" @click="userImgList()">-->
<!--              <span>全部图片</span>-->
<!--            </div>-->
          </el-space>
          <div>
            <el-button @click="editStandardImg(-1)">+ 上传图片</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="打卡说明：">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="非必填" v-model="standardForm.description"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateStandard, listStandardImg, delStandardImg} from "@/api/url";
import {greaterIntReg, phoneReg} from "@/assets/shared/reg-constant";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import Dialog from "@/assets/js/dialog";
import { moneyReg, positiveIntReg } from "@/assets/shared/reg-constant";
import StandardImgUpload from "@/views/hygiene/components/StandardImgUpload";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      standardForm: this.value.standardForm,
      idx: this.value.ids,

      shopIdArray: [],
      shopId: this.value.standardForm.shopId?this.value.standardForm.shopId:'',

      typeArray: [
        {label: '每日卫生打卡', value: 1},
        {label: '每周卫生打卡', value: 2},
        {label: '每月卫生打卡', value: 3}
      ],
      type: this.value.standardForm.type?this.value.standardForm.type:'',

      imgArray: this.value.standardForm.standardImgList?this.value.standardForm.standardImgList:[],

    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.shopId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择所属门店',
          type: 'warning'
        });
        return false
      }
      if(!this.type) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择卫生打卡类型',
          type: 'warning'
        });
        return false
      }
      if(!this.standardForm.area) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入区域',
          type: 'warning'
        });
        return false
      }
      if(!this.standardForm.location) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入位置',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.standardForm.orderNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先输入排序数值',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx > -1?this.standardForm.id:0;
      param['shopId'] = this.shopId;
      param['type'] = this.type;
      param['area'] = this.standardForm.area;
      param['location'] = this.standardForm.location;
      param['orderNum'] = this.standardForm.orderNum;
      param['description'] = this.standardForm.description;
      postFormData(addOrUpdateStandard, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },


    // userImgList() {
    //   let _title = '';
    //   _title = '图片列表'
    //   Drawer.open({
    //     title: _title,
    //     component: UserImgList,
    //     data: {
    //       imgArray: this.imgArray,
    //       id: this.standardForm.id,
    //       width: 908,
    //       from: 2,
    //     },
    //     confirm: (result) => {
    //       this.getStandardImgList()
    //     }
    //   })
    // },


    //选取图片
    editStandardImg(idx, row) {
      let _title = '';
      let imgForm = {}
      if (idx > -1) {
        _title = '编辑示例图'
        imgForm = Object.assign({}, row);
      }else {
        _title = '上传示例图'
      }
      Dialog.open({
        title: _title,
        component: StandardImgUpload,
        data: {
          hygieneStandardId: this.standardForm.id,
          imgForm: imgForm,
          width: '400px',
          ids: idx
        },
        confirm: (result) => {
          this.getStandardImgList()
        }
      })
    },

    getStandardImgList() {
      getFormData(listStandardImg, {id: this.standardForm.id}).then(data=> {
        this.imgArray = data.data
      })
    },

    delImg(item, idx) {
      this.$confirm('确认删除吗？').then(() => {
        let arr = []
        arr.push(item.id)
        postFormData(delStandardImg, {idArr: arr}).then(data => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.imgArray.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })
    }


  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    // if(this.idx == -1) {
    //   this.shopId = this.shopIdArray[0].id
    // }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ccc;
  font-size: 12px;
  cursor: pointer;
  /*float: left;*/
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.cover-tag {
  position: absolute;
  height: 20px;
  width: 32px;
  top: 0;
  left: 0;
  /*padding: 0 8px;*/
  text-align: center;
  line-height: 20px;
  font-size: 10px;
  color: #ffffff;
  background-color: #409eff;
  border-bottom-right-radius: 4px;
}

.line-btn {
  color: #409eff;
  cursor: pointer;
}

.line-btn:hover {
  text-decoration: underline;
}

</style>
